import React, { useEffect } from 'react';
import { SalesPage } from './pages/SalesPage';
import { initMetaPixel, trackCheckoutClicks, trackPixelEvent } from './utils/metaPixel';
import { CHECKOUT_URL, META_PIXEL_ID } from './data/product';
const productParams = {
  content_name: 'Halloween PE Ready',
  content_type: 'product',
  value: 19,
  currency: 'USD'
};
const INTERACTION_EVENTS = ['scroll', 'pointerdown', 'touchstart', 'keydown'] as const;
export function App() {
  useEffect(() => {
    // Load the pixel on the visitor's first interaction (or after 6s) so it never slows the first paint.
    let loaded = false;
    const load = () => {
      if (loaded) return;
      loaded = true;
      cleanup();
      initMetaPixel(META_PIXEL_ID);
      trackPixelEvent('ViewContent', productParams);
    };
    const timer = window.setTimeout(load, 6000);
    const cleanup = () => {
      window.clearTimeout(timer);
      INTERACTION_EVENTS.forEach(e => window.removeEventListener(e, load));
    };
    INTERACTION_EVENTS.forEach(e => window.addEventListener(e, load, {
      once: true,
      passive: true
    }));
    const stopTracking = trackCheckoutClicks(CHECKOUT_URL, META_PIXEL_ID, productParams);
    return () => {
      cleanup();
      stopTracking();
    };
  }, []);
  return <SalesPage data-id="element-0" data-mp="3rcsxbs5mwadd" />;
}